import { useMemo } from 'react';

import { PermissionString, Roles } from '@interfaces/users.interface';

import useAuth from './useAuth';

const useUserPermissionGuard = (
  permissionString: PermissionString | null,
  relatedOnly?: boolean,
  excludeRoles?: Roles[],
) => {
  const { user } = useAuth();

  const [resource, permission] = useMemo(
    () => permissionString?.split('.') || ['', ''],
    [permissionString],
  );

  const hasPermission =
    (!user || !excludeRoles || !excludeRoles?.includes(user?.role)) &&
    (!permissionString ||
      !!user?.permissions.find(
        (p) =>
          (p.permission === 'MANAGE' || p.permission === permission) &&
          p.resource === resource &&
          (relatedOnly === undefined || relatedOnly === p.relatedOnly),
      ));

  return useMemo(() => hasPermission, [hasPermission]);
};

export default useUserPermissionGuard;
